import React,{useState,useEffect} from 'react';
import {Container, Body} from "../../theme/theme";
import {useDispatch} from 'react-redux';
import {useSelector} from "react-redux";
import {setRoute, handleResetQuote} from '../../redux/actions';
import {RootState} from "../../redux/reducers";
import { useHistory } from "react-router-dom";
import {CardCategory,CategoriesContainer,ImgHoverZoom,CategoryName,ShowMoreButton,ShowMoreButtonContainer} from "./style";
import BreadCrumb from '../../components/BreadCrumb';
import { language } from '../../utils/language';
import FreeShippingMinBanner from '../../components/FreeShippingMinBanner';
const Categories = () =>{

    const history = useHistory();
    const categoryState: any = useSelector((state: RootState) => state.category)
    const homeState: HomeStateType = useSelector((state: RootState) => state.home)
    const dispatch = useDispatch()
    const [showBlocks,setShowBlocks] = useState(1)
    const [categoryGroup] = useState(12)
    const handelShowMore = () => {
        setShowBlocks(showBlocks+1)
    }

    useEffect(()=>{
        dispatch(handleResetQuote())
        dispatch(setRoute({
            route: "/",
            routeName: "Categorías",
        }))
    }, [])

    const handleCategoryDetailRedirect = (categoryId:number, categoryName:string)=>{
        dispatch(setRoute({route: '/categories', routeName: categoryName}))
        history.push(`/vende/${homeState.catalogueUrlName}/detailcategory/${categoryId}`)
    }

    return (
        <Body>
            {/* <MobileNavBotton/> */}
            <BreadCrumb currentPage={"Categorías"}/>
            <FreeShippingMinBanner inContent />
                <Container>
                    <CategoriesContainer>
                        { 
                            categoryState.listCategory && categoryState.listCategory.length > 0
                            && categoryState.listCategory.slice(0, (showBlocks * categoryGroup)).map((category: any, index:number)=> (
                                    <CardCategory color={homeState.color} 
                                        key={index.toString()}
                                        onClick={()=>handleCategoryDetailRedirect(category.id, category.name)}>
                                        <ImgHoverZoom>
                                            <img src={category.logo} />
                                        </ImgHoverZoom>
                                        <CategoryName text={category.name}/>
                                    </CardCategory>
                                ))
                        }
                        
                    </CategoriesContainer>
                        {
                            (categoryState.listCategory.length>(showBlocks * categoryGroup) &&
                                categoryState.listCategory.length>0 && 
                                categoryState.listCategory.slice(0, (showBlocks * categoryGroup)).length % categoryGroup === 0 ) &&
                                <ShowMoreButtonContainer>
                            <ShowMoreButton color={homeState.color} onClick={() => handelShowMore()}>{language[homeState.default_language]["more"]}</ShowMoreButton>
                                </ShowMoreButtonContainer>
                        }
                </Container>
        </Body>

    )
}

export default Categories